// removed by extract-text-webpack-plugin
module.exports = {"loadingSpinner":"diVg7EB_1ORHp4gl1vDew","modalContent":"_14Oq2hMg9v14lQIc0Oov7b"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/LoadingModal.css
 ** module id = 715
 ** module chunks = 0 1
 **/